import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../../../../../components/Container/pageContainer'
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import { Main } from '../../../../../constant'
import { CustomBtn } from '../../../../../components/button/button'
import SuggestionInput from '../../../../../components/suggestionInput/suggestionInput'
import dayjs from 'dayjs'
import CustomTable from '../../../../../components/table/SimpleTable'
import { Input } from '../../../../../components/input/input'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { PostRequest } from '../../../../../redux/actions/PostRequest'
import StudentReportComponent from '../../../../../components/report/student'
import { ShowLoader } from '../../../../../redux/actions/loader'
import { TabPanel, TabContext } from '@mui/lab';
import ShowClass from '../../../../Dashboard/Attendance/studentAttendance/components/showClass';
import PrintBillDialog from './printBill';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import SimpleTableFees from '../../../../../components/table/SimpleTableFees'

const FeeSlipMulty = (props) => {
  const [data, setData] = useState(Main().Fee);
  const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
  const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
    getfilterdata
      .map((item) => [item.name, ''])
  ));
  const [currentTab, setCurrentTab] = useState(0); // State variable to control the current tab
  const [suggestions, setSuggestions] = useState();
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const WebSrn = localStorage.getItem('WebSrn');
  const url = useSelector((state) => state.Api);
  const [update, setUpdate] = useState(0);
  const [studentOldDetails, setStudentOldDetails] = useState()
  const [maxSelectableDate, setMaxSelectableDate] = useState();
  const [tableData, setTableData] = useState();
  const [defaulters, setDefaulters] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [totalStudents, setTotalStudents] = useState();
  const [getClassName, setGetClassName] = useState('');
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [openDialog, setOpenDialog] = useState(false);
  const [highlightClass, setHighlightClass] = useState(null);


  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };


  const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });

  const fetchstudent = (param) => {
    // console.log(param)
    dispatch(ShowLoader('1'))
    axios.post(url.showoldFessDetails, param, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
    })
      .then((res) => {
        if (res.status === 200)
        {
          res.data.StudentDetails.feesPage = true
          res.data.StudentDetails.transport = res.data.transport
          setStudentOldDetails(res.data);
          setMaxSelectableDate(dayjs(res.data.lastrecord))
          // setTimeout(()=>{
          dispatch(ShowLoader('0'))
          // },1000)
        }
      })
      .catch((err) => {
        dispatch(ShowLoader('0'))
        //console.error(err); // Log the error response for debugging
      });
  }
  function suggestionhandleInputChange (e) {
    setStudentOldDetails('')
    //console.log(e.target.name,e.target.value)
    setInputValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
      Ammount: '',
    }));
    const RollNum = { RollNum: e.target.value }
    fetchstudent(RollNum)
  }
  const ChangeDate = (e) => {
    // //console.log(`${e.$y}-${e.$M}-${e.$D}`)
    //console.log( `${e.$y}-${e.$M+1}-${e.$D}`)
    setInputValues((prevValues) => ({
      ...prevValues,
      Month: `${e.$y}-${e.$M + 1}-${e.$D}`,
    }));

  }
  const submitfunc = async (e) => {
    e.preventDefault();
    dispatch(ShowLoader('1'))
    const payload = { ...inputValues }
    //console.log(payload)
    await dispatch(await PostRequest(url.AddFess, userToken, payload))
    setUpdate((update) => update + 1)
    const RollNum = { RollNum: inputValues.RollNum }
    setStudentOldDetails('')
    setInputValues({ ...initialInputValues });  // Reset to initial values
    setInputValues((prevValues) => ({
      RollNum: inputValues.RollNum,
    }));
    fetchstudent(RollNum)
    dispatch(ShowLoader('0'))
    // console.log(studentOldDetails)
  }
  useEffect(() => {
    dispatch(ShowLoader('1'))
    try
    {
      axios.get(url.studentsuggestion, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200)
          {
            //console.log(res.data.message);
            setSuggestions(res.data.message);
            dispatch(ShowLoader('0'))
          }
        })
        .catch((err) => {
          //console.error(err); // Log the error response for debugging
        });
    } catch (err)
    {
      //console.error(err);
    }
  }, [update]);

  const handleChange = (event) => {
    // //console.log(event.target.value)
    setInputValues((prevValues) => ({
      ...prevValues,
    }));
    // props.GetSelectedValue([event.target.value, event.target.name]);
  };
  function handleInputChange (e) {
    setInputValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
      ['Discount']: studentOldDetails.FeesDetials.Discount
    }));
    //console.log(inputValues)
  }

  const ClearDues = () => {
    //console.log('clicked')
    dispatch(PostRequest(url.clearFees, userToken, { RollNum: studentOldDetails.result[0].RollNum }))
    setUpdate((update) => update + 1)
    fetchstudent({ RollNum: studentOldDetails.result[0].RollNum })
  }

  const updatefunc = (getparam) => {
    if (!tableData || !tableData.result)
    {
      console.warn('⚠️ tableData not loaded yet.');
      return;
    }

    // existing logic
    const getFilteredDataGettingClassName = tableData.result.filter(item => {
      if (item.ClassID === getparam)
      {
        setGetClassName(item.Class)
      }
    });

    const filteredData = tableData.result.filter(item => item.ClassID === getparam)
      .map(({ Picture, Class, ClassID, ...rest }) => rest);

    const totalAmmount = filteredData.reduce((sum, item) => sum + item.Ammount, 0);
    setTotalAmount(totalAmmount);
    setTotalStudents(filteredData.length);
    setDefaulters(filteredData);

    // update highlight
    setHighlightClass(getparam);
  }; 
  const openBill = () => {
    setOpenDialog(true);
  };

  const removeRec = (FeeId) => {
    // console.log(FeeId)
    // console.log(inputValues)
    // return false
    dispatch(ShowLoader('1'))
    axios.post(url.deleteFees, { FeeId }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
    })
      .then((res) => {
        if (res.status === 200)
        {
          dispatch(ShowLoader('0'))
          fetchstudent({ RollNum: inputValues?.RollNum })
        }
      })
      .catch((err) => {
        dispatch(ShowLoader('0'))
        //console.error(err); // Log the error response for debugging
      });
  }

  return (
    <TabContext value={currentTab.toString()}>
      <PageContainer title="Student Attendance">
         
          <form onSubmit={submitfunc}>
            <Grid container>
              <Grid item lg={6} md={9} sm={12} xs={12}>
                <SuggestionInput
                  handleInputChange={suggestionhandleInputChange}
                  Suggestions={suggestions}
                  placeholder='Roll No / Name'
                  name='RollNum'
                />
                {
                  studentOldDetails ? studentOldDetails.result && (
                    <>
                      <Grid container>
                        <Grid item lg={6}>
                          <Box mt={1}>
                            Monthly Fee :
                            <Typography sx={{ color: 'green' }} variant='b'>
                              {studentOldDetails.FeesDetials.MonthlyFee}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={6}>
                          <Box mt={1}>
                            Discount :
                            <Typography sx={{ color: 'green' }} variant='b'>
                              {studentOldDetails.FeesDetials.Discount}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={6}>
                          <Box mt={1}>
                            Dues :
                            <Typography sx={{ color: 'red' }} variant='b'>
                              {studentOldDetails.FeesDetials.reduceamount}
                              {/* {studentOldDetails.status[0]['Extra Paid']} */}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={6}>
                          <Box mt={1}>
                            Extra Paid :
                            <Typography sx={{ color: 'green' }} variant='b'>
                              {studentOldDetails.status[0]['Extra Paid']}
                            </Typography>
                          </Box>
                        </Grid>

                      </Grid>
                      <Input sx={{ margin: '15px 0px 0px' }} onChange={(event) => handleInputChange(event)} type='number' name="Ammount" placeholder='Amount' />
                      <Grid container>
                        {/* <Grid item lg={12}>
                                            {/* <Date sx={{width: '100%'}} /> */}

                        {/* {
                                                    maxSelectableDate && (
                                                        <FullDate throwfullevent={ChangeDate} name="Month" min={maxSelectableDate} width='100%' max={maxSelectableDate} />
                                                        )
                                                    }
                                            </Grid> */}
                        {/* } */}


                      </Grid>
                      {/* <CustomSelect items={['jan','feb']} /> */}
                      <Input sx={{ margin: '15px 0px 0px' }} onChange={(event) => handleInputChange(event)} name="comments" placeholder='Comments' />
                      {/* <br /> */}
                      <Box mt={1}></Box>
                      <CustomBtn disable={inputValues.Ammount == '' || inputValues.Ammount == undefined} data='Submit' />
                    </>
                  )
                    :
                    null
                }
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                {
                  studentOldDetails && (
                    <StudentReportComponent data={studentOldDetails.StudentDetails} />

                  )
                }
              </Grid>
            </Grid>
          </form>
          <Grid container>
            <Grid item lg={9} mt={4}>
              {
                // studentOldDetails && studentOldDetails.result != [] && studentOldDetails.result != [] ? 
                studentOldDetails && studentOldDetails.result.length != 0 && studentOldDetails.result != null && studentOldDetails.result != undefined ?
                  WebSrn == 8 || WebSrn == 13 ? //Rawayat School 
                    <SimpleTableFees removeRec={removeRec} data={studentOldDetails.result} />
                    :
                    <CustomTable data={studentOldDetails.result} />
                  :
                  null
              }
            </Grid>
            <Grid item lg={4} mt={3}>
              {studentOldDetails && studentOldDetails.result.length != 0 && studentOldDetails.result != null && studentOldDetails.result != undefined ?
                <Button onClick={openBill}>
                  Bill بل
                </Button>
                :
                null}

            </Grid>
          </Grid> 
 
      </PageContainer>
    </TabContext>

  );
}

FeeSlipMulty.propTypes = {}

export default FeeSlipMulty